import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './zh'
import en from './en'

Vue.use(VueI18n)

// 获取浏览器首选语言函数
function getBrowserLang() {
  const navLang = navigator.language || navigator.userLanguage || navigator.browserLanguage
  const prefix = navLang.split('-')[0]
  // 识别到中文返回zh，其余全部英文
  return prefix === 'zh' ? 'zh' : 'en'
}

const i18n = new VueI18n({
  // 本地无缓存时默认英文
  locale: localStorage.getItem('lang') || getBrowserLang() || 'en',
  messages: {
    zh,
    en
  }
})

export default i18n